import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=d20c33ac&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.scss?vue&type=style&index=0&id=d20c33ac&prod&lang=scss&scoped=true&"
import style1 from "./Profile.vue?vue&type=style&index=1&id=d20c33ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20c33ac",
  null
  
)

export default component.exports